import { Controller } from '@hotwired/stimulus'

// Reflects and resets the state of a group of radio-button filters.
// Keeps the label target in sync with the checked radios: either a readout
// of the current option ("Sort: Random") or a count of applied filters
// ("Filter (1)") when countDefault is set to the value that means "no
// filter applied". Each applied target counts as one additional applied
// filter carried by hidden fields instead of radios. The clear target
// resets every radio group back to countDefault, removes the applied
// targets, and resubmits the form.
export default class extends Controller {
  static targets = ['label', 'clear', 'applied']

  static values = {
    prefix: String,
    countDefault: String
  }

  connect() {
    this.updateLabel()
  }

  updateLabel() {
    if (this.hasCountDefaultValue) {
      const applied = this.radios.filter((radio) => radio.checked && radio.value !== this.countDefaultValue).length +
        this.appliedTargets.length
      this.labelTarget.textContent = applied > 0 ? `${this.prefixValue} (${applied})` : this.prefixValue
      if (this.hasClearTarget) this.clearTarget.classList.toggle('hidden', applied === 0)
    } else {
      const checked = this.radios.find((radio) => radio.checked)
      if (checked && checked.labels[0]) {
        this.labelTarget.textContent = `${this.prefixValue}: ${checked.labels[0].textContent.trim()}`
      }
    }
  }

  clear() {
    if (!this.hasCountDefaultValue) return

    this.radios.filter((radio) => radio.value === this.countDefaultValue).forEach((radio) => { radio.checked = true })
    this.appliedTargets.forEach((applied) => applied.remove())
    this.updateLabel()
    this.radios[0]?.form?.requestSubmit()
  }

  get radios() {
    return Array.from(this.element.querySelectorAll("input[type='radio']"))
  }
}
